import { createSlice } from '@reduxjs/toolkit';
import axios from '../../utils/axios';
import { dispatch } from '../store';

const initialState = {
  isInitializing: false,
  isLoading: false,
  error: null,
  analytics: [],
};

const slice = createSlice({
  name: 'loan-analytics',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
      if (!state.analytics || state.analytics.length === 0) {
        state.isInitializing = true;
      }
    },

    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
      state.isInitializing = false;
    },

    getAnalyticsSuccess(state, action) {
      state.isLoading = false;
      state.analytics = action.payload;
      state.isInitializing = false;
    },
  },
});

export function getLoanAnalytics(productType, searchTerm, startDate, endDate) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(
        `/loans/analytics/meta?productType=${productType}&searchTerm=${searchTerm}&startDateFilter=${startDate}&endDateFilter=${endDate}`
      );
      dispatch(slice.actions.getAnalyticsSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export default slice.reducer;
